import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ba881006"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-trace-source" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "条件筛选", -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "河道范围", -1))
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上游范围", -1))
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下游范围", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开始时间", -1))
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "结束时间", -1))
const _hoisted_18 = { class: "item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "超标因子", -1))
const _hoisted_20 = { class: "item" }
const _hoisted_21 = {
  id: "wrsy-map",
  class: "map"
}
const _hoisted_22 = { class: "map-tools" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "large-text" }, "地图复位", -1))
const _hoisted_24 = { class: "right" }
const _hoisted_25 = { class: "top" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-parts2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "title-parts1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "title-parts2" })
], -1))
const _hoisted_27 = { class: "content" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-parts3" }, null, -1))
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-parts2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "title-parts1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "title-parts2" })
], -1))
const _hoisted_31 = { class: "content" }
const _hoisted_32 = { class: "content" }
const _hoisted_33 = { class: "content" }

import { watch, onMounted, h, computed } from 'vue'
import { ref } from 'vue-demi'
import { Api, wrsyQuery, wrsyProblemQuery, DotMapDto, WrsyProblemQuery } from '@/api/publicApi'
import { Api as ScreenSj } from '@/api/screenSj'
import { MapService } from '@/utils/mapServices2'
import Bus from '@/config/Bus'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogTraceSource',
  props: {
  data: Object,
},
  setup(__props) {

const mapService2 = new MapService()
console.log('服务问题', mapService2)
const api = new Api()
const screenApi = new ScreenSj()
const props = __props
console.log(props.data)
// 河道范围
const riverRanges = ref([
  {
    value: 0.5,
    label: '0.5km',
  },
  {
    value: 1,
    label: '1km',
  },
  {
    value: 1.5,
    label: '1.5km',
  },
  {
    value: 2,
    label: '2km',
  },
  {
    value: 2.5,
    label: '2.5km',
  },
  {
    value: 3,
    label: '3km',
  },
])
// 上游范围
const upperRanges = ref([
  {
    value: 0.5,
    label: '0.5km',
  },
  {
    value: 1,
    label: '1km',
  },
  {
    value: 3,
    label: '3km',
  },
  {
    value: 5,
    label: '5km',
  },
  {
    value: 10,
    label: '10km',
  },
  {
    value: 15,
    label: '15km',
  },
  {
    value: 20,
    label: '20km',
  },
  {
    value: 30,
    label: '30km',
  },
  {
    value: 40,
    label: '40km',
  },
  {
    value: 50,
    label: '50km',
  },
])
// 下游范围
const lowerRanges = ref([
  {
    value: 0.5,
    label: '0.5km',
  },
  {
    value: 1,
    label: '1km',
  },
  {
    value: 3,
    label: '3km',
  },
  {
    value: 5,
    label: '5km',
  },
  {
    value: 10,
    label: '10km',
  },
  {
    value: 15,
    label: '15km',
  },
  {
    value: 20,
    label: '20km',
  },
  {
    value: 30,
    label: '30km',
  },
  {
    value: 40,
    label: '40km',
  },
  {
    value: 50,
    label: '50km',
  },
])
const riverRange = ref(0.5) // 河道范围
const upperRange = ref(5) // 上游范围
const lowerRange = ref(5) // 下游范围
const beginTime = ref(new Date(new Date() - 15 * 24 * 3600 * 1000))
const endTime = ref(new Date())
const cbFactor = ref('') // 超标因子
const emergencyDegree = ref(0) // 重要程度
const problemSource = ref(0) // 重要来源
const jd = ref('')
const wd = ref('')
const bufferRange = ref()
const cbFactorList = ref([]) // 超标因子下拉
const pointList = ref([])
const checkeds = ref([])
const problemList1 = ref([])
const problemList2 = ref([])
const problemList3 = ref([])
const pageContent = ref('水质异常报警')
const pageArr = ref(['污染源异常报警', '水质异常报警', '巡查上报'])
const tableData = ref([
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 3,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 2,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
])
const columns1 = ref([
  {
    title: '问题描述',
    key: 'problemDesc',
    align: 'center',
    ellipsis: {
      tooltip: {
        trigger: 'click',
      },
      'line-clamp': 2,
    },
  },
  {
    title: '报警时间',
    key: 'boomTime',
    width: 120,
    align: 'center',
  },
  {
    title: '报警类别',
    key: 'boomType',
    width: 80,
    align: 'center',
  },
  {
    title: '报警次数',
    key: 'boomCount',
    width: 80,
    align: 'center',
  },
])
const columns2 = ref([
  // {
  //   title: '序号',
  //   key: 'no',
  //   width: 60,
  //   align: 'center',
  //   render(row, index) {
  //     return h(
  //       `span`,
  //       {},
  //       {
  //         default: () => index + 1,
  //       }
  //     )
  //   },
  // },
  {
    title: '问题描述',
    key: 'problemDesc',
    align: 'center',
    ellipsis: {
      tooltip: {
        trigger: 'click',
      },
      'line-clamp': 2,
    },
  },
  {
    title: '报警时间',
    key: 'boomTime',
    width: 120,
    align: 'center',
  },
  {
    title: '报警类别',
    key: 'boomType',
    width: 80,
    align: 'center',
  },
  {
    title: '报警次数',
    key: 'boomCount',
    width: 80,
    align: 'center',
  },

  // {
  //   title: '状态',
  //   key: 'problemStatus',
  //   width: 80,
  //   align: 'center',
  //   render(row, index) {
  //     let className = 'tag dcl'
  //     let content = '待处理'
  //     if (row.problemStatus === 1) {
  //       className = 'tag dcl'
  //       content = '待处理'
  //     }
  //     if (row.problemStatus === 2) {
  //       className = 'tag clz'
  //       content = '处理中'
  //     }
  //     if (row.problemStatus === 3) {
  //       className = 'tag ywj'
  //       content = '已办结'
  //     }
  //     return h(
  //       `div`,
  //       {
  //         class: className,
  //       },
  //       {
  //         default: () => content,
  //       }
  //     )
  //   },
  // },
])
const columns3 = ref([
  {
    title: '序号',
    key: 'no',
    width: 60,
    align: 'center',
    render(row: any, index: number) {
      return h(
        `span`,
        {},
        {
          default: () => index + 1,
        }
      )
    },
  },
  {
    title: '问题描述',
    key: 'problemName',
    align: 'center',
    ellipsis: {
      tooltip: {
        trigger: 'click',
      },
      'line-clamp': 2,
    },
  },
  {
    title: '类别',
    key: 'problemTypeStr',
    width: 80,
    align: 'center',
  },
  {
    title: '时间',
    key: 'reportTime',
    width: 120,
    align: 'center',
  },
  {
    title: '状态',
    key: 'problemStatus',
    width: 80,
    align: 'center',
    render(row: { problemStatus: number }, index: any) {
      let className = 'tag dcl'
      let content = '待处理'
      if (row.problemStatus === 1) {
        className = 'tag dcl'
        content = '待处理'
      }
      if (row.problemStatus === 2) {
        className = 'tag clz'
        content = '处理中'
      }
      if (row.problemStatus === 3) {
        className = 'tag ywj'
        content = '已办结'
      }
      return h(
        `div`,
        {
          class: className,
        },
        {
          default: () => content,
        }
      )
    },
  },
])

// yyyy-MM-dd格式的起始和结束时间
const formatBeginTime = computed(() => {
  return formatTime(beginTime.value)
})
const formatEndTime = computed(() => {
  return formatTime(endTime.value)
})
watch(beginTime, (newValue, oldValue) => {
  selectPoint()
  selectProblem()
})
watch(endTime, (newValue, oldValue) => {
  selectPoint()
  selectProblem()
})
watch(riverRange, (newValue, oldValue) => {
  selectPoint()
  selectProblem()
})
watch(upperRange, (newValue, oldValue) => {
  console.log(newValue, oldValue, 'upperRange')
  selectPoint()
  selectProblem()
})
watch(lowerRange, (newValue, oldValue) => {
  selectPoint()
  selectProblem()
})

const getCbFactorUsingGet = () => {
  api.screen.getCbFactorUsingGet().then((res) => {
    if (res.code === 200) {
      cbFactor.value = res.data[0].name
      if (!props.data.selectFactor) {
        cbFactor.value = res.data[0].name
      }
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].name == props.data.selectFactor) {
          cbFactor.value = props.data.selectFactor
        }
        res.data[i].label = res.data[i].name
      }
      cbFactorList.value = res.data
    }
  })
}
getCbFactorUsingGet()

const formatTime = (val: {
  toString: () => string
  toDateString: () => string
  toTimeString: () => string
  toLocaleString: {
    (): string
    (
      locales?: string | string[] | undefined,
      options?: Intl.DateTimeFormatOptions | undefined
    ): string
    (locales?: Intl.LocalesArgument, options?: Intl.DateTimeFormatOptions | undefined): string
  }
  toLocaleDateString: {
    (): string
    (
      locales?: string | string[] | undefined,
      options?: Intl.DateTimeFormatOptions | undefined
    ): string
    (locales?: Intl.LocalesArgument, options?: Intl.DateTimeFormatOptions | undefined): string
  }
  toLocaleTimeString: {
    (): string
    (
      locales?: string | string[] | undefined,
      options?: Intl.DateTimeFormatOptions | undefined
    ): string
    (locales?: Intl.LocalesArgument, options?: Intl.DateTimeFormatOptions | undefined): string
  }
  valueOf: () => number
  getTime: () => number
  getFullYear: () => number
  getUTCFullYear: () => number
  getMonth: () => number
  getUTCMonth: () => number
  getDate: () => number
  getUTCDate: () => number
  getDay: () => number
  getUTCDay: () => number
  getHours: () => number
  getUTCHours: () => number
  getMinutes: () => number
  getUTCMinutes: () => number
  getSeconds: () => number
  getUTCSeconds: () => number
  getMilliseconds: () => number
  getUTCMilliseconds: () => number
  getTimezoneOffset: () => number
  setTime: (time: number) => number
  setMilliseconds: (ms: number) => number
  setUTCMilliseconds: (ms: number) => number
  setSeconds: (sec: number, ms?: number | undefined) => number
  setUTCSeconds: (sec: number, ms?: number | undefined) => number
  setMinutes: (min: number, sec?: number | undefined, ms?: number | undefined) => number
  setUTCMinutes: (min: number, sec?: number | undefined, ms?: number | undefined) => number
  setHours: (
    hours: number,
    min?: number | undefined,
    sec?: number | undefined,
    ms?: number | undefined
  ) => number
  setUTCHours: (
    hours: number,
    min?: number | undefined,
    sec?: number | undefined,
    ms?: number | undefined
  ) => number
  setDate: (date: number) => number
  setUTCDate: (date: number) => number
  setMonth: (month: number, date?: number | undefined) => number
  setUTCMonth: (month: number, date?: number | undefined) => number
  setFullYear: (year: number, month?: number | undefined, date?: number | undefined) => number
  setUTCFullYear: (year: number, month?: number | undefined, date?: number | undefined) => number
  toUTCString: () => string
  toISOString: () => string
  toJSON: (key?: any) => string
  getVarDate: () => VarDate
  [Symbol.toPrimitive]: {
    (hint: 'default'): string
    (hint: 'string'): string
    (hint: 'number'): number
    (hint: string): string | number
  }
}) => {
  let res = ''
  if (val instanceof Date) {
    const year = val.getFullYear()
    let month = val.getMonth() + 1
    let day = val.getDate()
    if (month < 10) {
      month = `0${month}`
    }
    if (day < 10) {
      day = `0${day}`
    }
    res = `${year}-${month}-${day}`
  }
  return res
}

const endTimeChange = (time: string | number | Date) => {
  // let timeArr = time.split('-')
  // let now = new Date(timeArr[0], timeArr[1]-1, timeArr[2])
  // let now = new Date(timeArr[0], timeArr[1]-1, timeArr[2])
  const day15ago = new Date(time - 15 * 24 * 3600 * 1000)
  beginTime.value = day15ago
  endTime.value = new Date(time)
}

const selectContent = (val: string) => {
  pageContent.value = val
  selectProblem()
}

const initmap = () => {
  mapService2.initMap(
    {
      container: 'wrsy-map',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/ht新河长大屏-详情.json',
      center: [
        props.data.longitude ? parseFloat(props.data.longitude) : parseFloat(props.data.jd),
        props.data.latitude ? parseFloat(props.data.latitude) : parseFloat(props.data.wd),
      ],
      zoom: 12,
      minZoom: 9.5,
      bearing: -11.799999999999704,
      antialias: true,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA',
    this
  )
  mapService2.map.once('styledata', () => {
    /* eslint-disable */
    mapService2.addImage(require('@/assets/img/map/riverDetails.png'), 'riverDetails.png')
    setTimeout(() => {
      selectPoint()
      selectProblem()
    }, 2000)
  })
}
// 点位搜索
const selectPoint = () => {
  mapService2.removeLayer('problemPoint')
  mapService2.removeLayer('origin')
  bufferRange.value = mapService2.getBufferRange(
    [
      props.data.longitude ? parseFloat(props.data.longitude) : parseFloat(props.data.jd),
      props.data.latitude ? parseFloat(props.data.latitude) : parseFloat(props.data.wd),
    ],
    riverRange.value,
    upperRange.value,
    lowerRange.value
  )
  mapService2.addCirclePointsLayer('origin', [bufferRange.value.origin], 4)
  console.log(bufferRange.value, 'bufferRange')
  getPointList()
  const bbox = getBbox(bufferRange.value.polygon.geometry.coordinates)
  mapService2.fitBounds(bbox)
  mapService2.drawBufferRange(bufferRange.value.polygon)
}

// 获取范围两角坐标
const getBbox = (data: [undefined, any][][]) => {
  let minLng = data[0][0][0]
  let maxLng = data[0][0][0]
  let minLat = data[0][0][1]
  let maxLat = data[0][0][1]
  for (let i = 0; i < data[0].length; i += 1) {
    if (data[0][i][0] < minLng) {
      ;[minLng] = data[0][i]
    } else if (data[0][i][0] > maxLng) {
      ;[maxLng] = data[0][i]
    }
    if (data[0][i][1] < minLat) {
      ;[, minLat] = data[0][i]
    }
    if (data[0][i][1] > maxLat) {
      ;[, maxLat] = data[0][i]
    }
  }
  return [
    [minLng, minLat],
    [maxLng, maxLat],
  ]
}

const getMapIcon2 = (data: DotMapDto) => {
  let icon = ''
  let modalType = ''
  switch (data.categoryStr) {
    case '一体化水质自动监测站':
      modalType = '自动监测断面'
      if (data.gkjb) {
        if (data.gkjb === '区县控') {
          icon = '区控'
        } else {
          icon = data.gkjb
        }
      }
      break
    case '物联型水质自动监测站':
      modalType = '自动监测断面'
      if (data.gkjb) {
        if (data.gkjb === '区县控') {
          icon = '区控'
        } else {
          icon = data.gkjb
        }
      }
      break
  }
  switch (icon) {
    case '区控':
    case '市控':
    case '国控':
    case '一体化':
      icon = icon + '_1类'
      break
    default:
      if (data.online) {
        // 是否在线
        if (data.standard) {
          // 是否超标
          if (data.standard === 'cb') {
            icon = `${icon}_1`
          }
          if (data.standard === 'wsj') {
            icon = `${icon}_0`
          }
        }
      }
  }
  icon = `${icon}.png`
  return { ...data, icon, modalType }
}

const getMapIcon = (type: string | undefined, data: DotMapDto) => {
  let icon = ''
  let modalType = ''
  switch (type) {
    case '手工监测站':
      modalType = '手工监测断面'
      if (data.gkjb) {
        if (data.gkjb === '区县控') {
          icon = '区控'
        } else {
          icon = data.gkjb
        }
      }
      break
    case '一体化自动站':
      modalType = '自动监测断面'
      icon = '一体化'
      break
    case '物联站':
      icon = '物联'
      modalType = '自动监测断面'
      break
    case '重点工业企业':
      icon = '工业企业'
      modalType = '工业企业'
      break
    case '畜牧养殖':
      icon = '畜禽养殖场'
      modalType = 'gmhxmyz'
      break
    case '水产养殖':
      icon = '水产养殖场'
      modalType = 'scyz'
      break
    case '污水处理厂':
      icon = '污水厂'
      modalType = '污水处理厂'
      break
    case '农贸市场':
      icon = '农贸市场'
      modalType = '农贸市场'
      break
    case '水文站':
      icon = '水文站'
      modalType = '水文站'
      break
    case '水位站':
      icon = '水位站'
      modalType = '水文站'
      break
    case '雨量站':
      icon = '雨量站'
      modalType = '水文站'
      break
    default:
  }
  switch (icon) {
    case '区控':
    case '市控':
    case '国控':
    case '一体化':
      icon = icon + '_1类'
      break
    default:
      if (data.online) {
        // 是否在线
        if (data.standard) {
          // 是否超标
          if (data.standard === 'cb') {
            icon = `${icon}_1`
          }
          if (data.standard === 'wsj') {
            icon = `${icon}_0`
          }
        }
      }
  }

  icon = `${icon}.png`
  return { ...data, icon, modalType }
}

//--------------------------------------点位筛选树-----------------------------------------

const defaultExpandedKeys = ref([])

// 获取点位
const getPointList = () => {
  const [...layers] = mapService2.map.getStyle().layers
  console.log(layers, 'layers')
  for (let i = 0; i < layers.length; i += 1) {
    if (layers[i].id.indexOf('_point') >= 0) {
      mapService2.removeLayer(layers[i].id)
    }
  }
  treeChecked.value = []
  const params: wrsyQuery = {
    beginTime: format(beginTime.value),
    endTime: format(endTime.value),
    points: bufferRange.value.line.geometry.coordinates,
    cbFactor: cbFactor.value,
    scope: riverRange.value * 1000,
  }
  api.screen.getWrsyPointListUsingPost(params).then((res) => {
    defaultExpandedKeys.value = []
    pointList.value = res.data.map((item) => {
      // defaultExpandedKeys.value.push(item.name) // 默认展开
      return {
        label: `${item.name} (${item.count})`,
        key: item.name,
        isChild: false,
        children: item.datas?.map((i, index) => {
          // 添加点位图层
          const data = []
          let cb = 0
          for (let n = 0; n < i.datas.length; n += 1) {
            if (i.datas[n].standard === 'cb') {
              cb += 1
            }
            data.push({
              coordinates: [parseFloat(i.datas[n].jd), parseFloat(i.datas[n].wd)],
              properties: {
                ...getMapIcon(i.name, i.datas[n]),
                visibility: 'none',
              },
            })
          }
          mapService2.addPointsLayer(`${i.name}_point`, data, '', 1)
          //默认隐藏
          mapService2.hideLayer(`${i.name}_point`)
          return {
            label: `${i.name} (${i.count})`,
            key: i.name,
            isChild: true,
            ...i,
          }
        }),
      }
    })
    const list = [];
    pointList.value.forEach(item => {
      if (item && item.key === '水质站') {
        list.push(item.key)
        if (item.children && item.children.length) {
          item.children.forEach(item2 => {
            list.push(item2.key)
          })
        }
      }
    })
    updateCheckedKeys(list)
  })
}
const treeChecked = ref<string | any[]>([])
const updateCheckedKeys = (keys: string | any[], options: any, meta: any) => {
  console.log('updateCheckedKeys', keys, options, meta)
  treeChecked.value = keys

  pointList.value.forEach((item) => {
    item.children.forEach((i: { name: any }) => {
      if (keys.includes(i.name)) {
        mapService2.showLayer(`${i.name}_point`)
      } else {
        mapService2.hideLayer(`${i.name}_point`)
      }
    })
  })
  if (keys.length > 0) {
    mapService2.hideLayer('szProblemPoint')
  } else {
    mapService2.showLayer('szProblemPoint')
  }
}

// 问题搜索
const selectProblem = () => {
  mapService2.removeLayer('problemPoint')
  const params: wrsyProblemQuery = {
    beginTime: format(beginTime.value),
    endTime: format(endTime.value),
    points: bufferRange.value.line.geometry.coordinates,
    emergencyDegree: 0,
    // problemSource: 0,
    cbFactor: cbFactor.value,
    jd: props.data.longitude ? parseFloat(props.data.longitude) : parseFloat(props.data.jd),
    wd: props.data.latitude ? parseFloat(props.data.latitude) : parseFloat(props.data.wd),
    syfw: upperRange.value * 1000,
    xyfw: lowerRange.value * 1000,
    scope: riverRange.value * 1000,
  }
  switch (pageContent.value) {
    case '污染源异常报警':
      getWrsyBoomListUsingPost(params)
      break
    case '水质异常报警':
      getWrsySzBoomListUsingPost(params)
      break
    case '巡查上报':
      getWrsyProblemListUsingPost(params)
      break
  }
}

//水质异常报警清单
const szProblemDotMapList = ref([])
const getWrsySzBoomListUsingPost = (params: WrsyProblemQuery) => {
  console.log(2, 'getWrsySzBoomListUsingPost')
  screenApi.screen.getWrsyBoomListUsingPost(params).then((res) => {
    szProblemDotMapList.value = []
    problemList2.value = res.data?.map((item) => {
      szProblemDotMapList.value.push({
        coordinates: [parseFloat(item.dotMap.jd), parseFloat(item.dotMap.wd)],
        properties: {
          ...getMapIcon2(item.dotMap),
        },
      })
      return {
        ...item,
      }
    })
    console.log(szProblemDotMapList.value, 'szProblemDotMapList.value')
    mapService2.removeLayer('szProblemPoint')
    mapService2.addPointsLayer('szProblemPoint', szProblemDotMapList.value, '', 1)
  })
}

//污染源异常报警青清单
const wrsyPointList = ref([])
const getWrsyBoomListUsingPost = (params) => {
  console.log(1, 'getWrsyBoomListUsingPost')
  wrsyPointList.value = []
  screenApi.screen.getWrsySzBoomListUsingPost(params).then((res) => {
    problemList1.value = res.data?.map((item) => {
      wrsyPointList.value.push({
        ...item.data[0],
        jd: item.jd,
        wd: item.wd,
        type: item.boomType,
      })
      return {
        ...item,
      }
    })
    showWrsyPoint()
  })
}
const showWrsyPoint = () => {
  const datas = wrsyPointList.value.map((item) => {
    return {
      coordinates: [parseFloat(item.jd), parseFloat(item.wd)],
      properties: {
        modalType: '问题详情',
        icon: 'riverDetails.png',
        category: 'zdgj',
        ...item,
      },
    }
  })
  mapService2.removeLayer('wrsyProblemPoints')
  mapService2.addPointsLayer('wrsyProblemPoints', datas, '', 1)
}
//问题列表
const getWrsyProblemListUsingPost = (params: WrsyProblemQuery) => {
  console.log(3, 'getWrsyProblemListUsingPost')
  api.screen.getWrsyProblemListUsingPost(params).then((res) => {
    problemList3.value = res.data
  })
}

// 点管理
const pointsManage = (e: any, data: string | any[]) => {
  console.log('pointsManage', e, data)
  if (e) {
    for (let i = 0; i < data.length; i += 1) {
      mapService2.showLayer(`${data[i].name}_point`)
    }
  } else {
    for (let i = 0; i < data.length; i += 1) {
      mapService2.hideLayer(`${data[i].name}_point`)
    }
  }
}

// 点击问题
const clickProblem = (data: { longitude: any; latitude: any; category: string; deviceMn: any }) => {
  let properties = {
    ...data,
    jd: data.longitude,
    wd: data.latitude,
  }
  if (data.category != 'xcsb') {
    properties.id = data.deviceMn
  }
  // Bus.emit('mapClick2', { properties: properties })
}

const selectChange = (val: any) => {
  selectPoint()
  selectProblem()
}

const clickEvent = (val: any) => {
  switch (val) {
    case '地图复位':
      mapService2.flyTo({
        center: [parseFloat(props.data.longitude), parseFloat(props.data.latitude)],
        zoom: 12,
      })
      break
  }
}

const mapClick = (data: unknown) => {
  Bus.emit('mapClick2', data)
}

const forecast = () => {
  if (props.data.name === '茨坝') {
    // Bus.emit('mapClick2', { data: { category: 'yc' }, modalType: 'yc' })
  }
}

function add0(m: string | number) {
  return m < 10 ? '0' + m : m
}
function format(shijianchuo: string | number | Date) {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo)
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  // var h = time.getHours();
  // var mm = time.getMinutes();
  // var s = time.getSeconds();
  // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
  return y + '-' + add0(m) + '-' + add0(d)
}

onMounted(() => {
  initmap()
})

return (_ctx: any,_cache: any) => {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_tree = _resolveComponent("n-tree")!
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_n_data_table = _resolveComponent("n-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.data.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_n_select, {
              value: _unref(riverRange),
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(riverRange) ? (riverRange).value = $event : null)),
              size: "small",
              options: _unref(riverRanges)
            }, null, 8, ["value", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_n_select, {
              value: _unref(upperRange),
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(upperRange) ? (upperRange).value = $event : null)),
              size: "small",
              options: _unref(upperRanges)
            }, null, 8, ["value", "options"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_n_select, {
              value: _unref(lowerRange),
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(lowerRange) ? (lowerRange).value = $event : null)),
              size: "small",
              options: _unref(lowerRanges)
            }, null, 8, ["value", "options"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_n_date_picker, {
              value: _unref(beginTime),
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_isRef(beginTime) ? (beginTime).value = $event : null)),
              size: "small",
              type: "date",
              clearable: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_n_date_picker, {
              value: _unref(endTime),
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_isRef(endTime) ? (endTime).value = $event : null)),
              size: "small",
              type: "date",
              "on-update:value": endTimeChange,
              clearable: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_n_select, {
              value: _unref(cbFactor),
              "onUpdate:value": [
                _cache[5] || (_cache[5] = ($event: any) => (_isRef(cbFactor) ? (cbFactor).value = $event : null)),
                selectChange
              ],
              size: "small",
              options: _unref(cbFactorList)
            }, null, 8, ["value", "options"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_n_tree, {
              "block-line": "",
              cascade: "",
              checkable: "",
              data: _unref(pointList),
              "checked-keys": _unref(treeChecked),
              "default-expanded-keys": _unref(defaultExpandedKeys),
              "on-update:checked-keys": updateCheckedKeys
            }, null, 8, ["data", "checked-keys", "default-expanded-keys"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_n_popover, {
            overlap: _ctx.overlap,
            to: false,
            delay: 0,
            trigger: "hover"
          }, {
            trigger: _withCtx(() => [
              _createElementVNode("span", {
                class: "img-btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (clickEvent('地图复位')))
              })
            ]),
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }, 8, ["overlap"])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageArr), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: _normalizeClass(["title", { active: _unref(pageContent) === item }]),
                onClick: ($event: any) => (selectContent(item))
              }, _toDisplayString(item), 11, _hoisted_29))
            }), 128))
          ]),
          _hoisted_30
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_31, [
          _createVNode(_component_n_data_table, {
            "max-height": "658",
            style: {"width":"480px"},
            columns: _unref(columns1),
            data: _unref(problemList1),
            pagination: false,
            bordered: false
          }, null, 8, ["columns", "data"])
        ], 512), [
          [_vShow, _unref(pageContent) === '污染源异常报警']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_32, [
          _createVNode(_component_n_data_table, {
            "max-height": "658",
            style: {"width":"480px"},
            columns: _unref(columns2),
            data: _unref(problemList2),
            pagination: false,
            bordered: false
          }, null, 8, ["columns", "data"])
        ], 512), [
          [_vShow, _unref(pageContent) === '水质异常报警']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_33, [
          _createVNode(_component_n_data_table, {
            "max-height": "658",
            style: {"width":"480px"},
            columns: _unref(columns3),
            data: _unref(problemList3),
            pagination: false,
            bordered: false
          }, null, 8, ["columns", "data"])
        ], 512), [
          [_vShow, _unref(pageContent) === '巡查上报']
        ])
      ])
    ])
  ]))
}
}

})